export default "__VITE_ASSET__DWb3W7xY__"